import { render, staticRenderFns } from "./generarCotizacion.vue?vue&type=template&id=2f524b48&lang=pug"
import script from "./generarCotizacion.vue?vue&type=script&lang=js"
export * from "./generarCotizacion.vue?vue&type=script&lang=js"
import style0 from "./generarCotizacion.vue?vue&type=style&index=0&id=2f524b48&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports